import { useEffect } from 'react';

export default function About() {
  useEffect(() => {
    document.title = '关于我们 - 中文字幕一区二区三区四虎在线';
  }, []);

  return (
    <div className="max-w-[1400px] mx-auto px-4 md:px-6 py-8 md:py-12">
      <header className="max-w-3xl">
        <h1 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950">关于我们</h1>
        <p className="mt-4 text-sm md:text-base leading-relaxed text-foreground-700">
          中文字幕一区二区三区四虎在线是一个面向中文影视内容爱好者的在线影视浏览与观看（演示）平台。我们聚焦中文影视资源的分类浏览与在线观看体验，收录电影、电视剧、综艺等多个频道的演示内容，帮助用户快速查找带中文字幕的高清影视作品，并提供清晰的信息与相关内容推荐。
        </p>
      </header>

      <section className="mt-10 grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-5">
        <div className="rounded-lg bg-background-50 border border-background-200 p-5">
          <span className="w-11 h-11 rounded-lg bg-primary-500 text-background-50 flex items-center justify-center mb-3">
            <i className="ri-film-line text-xl"></i>
          </span>
          <h2 className="text-base font-semibold text-foreground-950">丰富的中文字幕资源</h2>
          <p className="mt-2 text-sm leading-relaxed text-foreground-600">
            覆盖电影、电视剧、综艺等多种类型，题材包含科幻、动作、悬疑、古装、都市、美食等，满足不同观影偏好。
          </p>
        </div>
        <div className="rounded-lg bg-background-50 border border-background-200 p-5">
          <span className="w-11 h-11 rounded-lg bg-secondary-500 text-background-50 flex items-center justify-center mb-3">
            <i className="ri-search-eye-line text-xl"></i>
          </span>
          <h2 className="text-base font-semibold text-foreground-950">高效检索与筛选</h2>
          <p className="mt-2 text-sm leading-relaxed text-foreground-600">
            支持关键词搜索与类型、地区、年份多维筛选，以及按更新日期和热门程度排序，快速定位想看的内容。
          </p>
        </div>
        <div className="rounded-lg bg-background-50 border border-background-200 p-5">
          <span className="w-11 h-11 rounded-lg bg-accent-500 text-background-50 flex items-center justify-center mb-3">
            <i className="ri-device-line text-xl"></i>
          </span>
          <h2 className="text-base font-semibold text-foreground-950">多端舒适体验</h2>
          <p className="mt-2 text-sm leading-relaxed text-foreground-600">
            页面自适应电脑与手机，卡片式列表浏览顺畅，详情信息分区清晰，随时随地查看影视资讯。
          </p>
        </div>
      </section>

      <section className="mt-10 rounded-lg bg-background-100 border border-background-200 p-6 md:p-8 max-w-3xl">
        <h2 className="text-lg md:text-xl font-heading font-bold text-foreground-950">联系方式</h2>
        <p className="mt-3 text-sm leading-relaxed text-foreground-700">
          如对网站内容、使用体验有任何建议或反馈，欢迎通过邮箱与我们联系。我们暂未开通在线客服功能，收到邮件后会尽快查看处理。
        </p>
        <div className="mt-5 flex flex-wrap items-center gap-3">
          <span className="inline-flex items-center gap-2 px-4 py-3 rounded-md bg-background-50 border border-background-300 text-sm text-foreground-900">
            <i className="ri-mail-line text-primary-500"></i>
            contact@zhongwenzimu.example.com
          </span>
        </div>
      </section>

      <section className="mt-10 max-w-3xl">
        <h2 className="text-lg md:text-xl font-heading font-bold text-foreground-950">免责声明</h2>
        <div className="mt-3 space-y-3 text-sm leading-relaxed text-foreground-700">
          <p>
            本站为前端演示站点，页面中的影视名称、封面、简介、评分、热度等信息均为演示数据，不代表任何真实影视作品或平台。
          </p>
          <p>
            站内播放器区域为演示占位，标明“即将上线”提示，不提供、也不实现任何真实的视频播放、下载或资源存储服务。
          </p>
          <p>
            本站不涉及会员、登录与支付功能。用户的收藏状态仅保存在其浏览器本地，不会上传至服务器，也不会用于任何统计用途。
          </p>
        </div>
      </section>

      <section className="mt-10 max-w-3xl">
        <h2 className="text-lg md:text-xl font-heading font-bold text-foreground-950">版权信息</h2>
        <p className="mt-3 text-sm leading-relaxed text-foreground-700">
          © 2026 中文字幕一区二区三区四虎在线 · 本站内容仅用于学习与技术演示。如对演示内容有异议，可通过上方邮箱联系我们进行沟通与调整。
        </p>
      </section>
    </div>
  );
}